import React, {useEffect, useState} from "react";
import * as Yup from "yup";
import {Grid, IconButton, Popover, TextField, Typography} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

const LinkToSalesForcePopoverEdit = ({cell, row, handleUpdateCellCallBack}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [popOverValue, setPopOverValue] = useState(cell.getValue());
    const [value, setValue] = useState(cell.getValue());
    const [error, setError] = useState('');
    const open = Boolean(anchorEl);
    const id = open ? 'popover-edit-url' : undefined;

    useEffect(() => {
        setValue(cell.getValue() || '');
    }, [cell]);

    useEffect(() => {
        setPopOverValue(value);
    }, [value]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setPopOverValue(value);
        setError('');
    };

    const handleSave = async () => {
        try {
            const schema = Yup.object().shape({
                url: Yup.string().url('Invalid URL'),
            });
            await schema.validate({url: popOverValue});
            setError('');
            setValue(popOverValue);
            handleUpdateCellCallBack(row.original.id, 'linkToSalesForce', popOverValue, row.original);
            handleClose();
        } catch (error) {
            setError(error.errors[0]);
        }
    };

    const truncate = (text, maxLength) => {
        if (text?.length > maxLength) {
            return text.substring(0, maxLength) + '...';
        }
        return text;
    };

    return (
        <Grid container wrap="nowrap" alignItems="center" spacing={1}>
            <Grid item xs style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}>
                <Typography variant="body2" noWrap component="a" href={value} target="_blank" rel="noopener noreferrer">
                    {truncate(value, 30)}
                </Typography>
            </Grid>
            <Grid item>
                <IconButton aria-describedby={id} size="small" onClick={handleClick}>
                    <EditIcon fontSize="small"/>
                </IconButton>
            </Grid>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Grid container direction="column" spacing={1} p={2}>
                    <Grid item>
                        <TextField
                            autoFocus
                            fullWidth
                            size="small"
                            value={popOverValue}
                            onChange={(e) => {
                                setError('');
                                setPopOverValue(e.target.value);
                            }}
                            error={!!error}
                            helperText={error}
                        />
                    </Grid>
                    <Grid item container spacing={1} justifyContent="flex-end">
                        <Grid item>
                            <IconButton color="primary" onClick={handleSave} style={{color: 'green'}}>
                                <CheckIcon/>
                            </IconButton>
                        </Grid>
                        <Grid item>
                            <IconButton color="secondary" onClick={handleClose} style={{color: 'red'}}>
                                <CloseIcon/>
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Popover>
        </Grid>
    );
};

export default LinkToSalesForcePopoverEdit;
